import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import styled from 'styled-components';
import Container from 'components/Container';
import ContainerHeader from 'components/ContainerHeader';
import { HelpModals } from 'components/HelpModals';
import Icon from 'components/Icon';
import Spacer from 'components/Spacer';
import { Table } from 'components/Table';
import Text from 'components/Text';
import { EventHeader } from 'pages/app/Events/EventsMenu/components/EventHeader';
import { Column } from 'pages/app/Events/Header/StyledHeader';
import { CashDrawerReportPrint } from './CashDrawerReport/CashDrawerReportPrint';
import { useGetCashDrawerReport } from './gql/mutation/useGetCashDrawerReport.mutation';

const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const FilterContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  justify-content: space-between;
  max-width: 80vw;
`;

export const CashDrawerReport = () => {
  const [cashDrawerReport, setCashDrawerReport] = useState();
  const { id } = useParams();

  const location = useLocation();
  const { event } = location.state || {};

  const getCashDrawerReport = useGetCashDrawerReport();

  const eventData = event || cashDrawerReport?.event;

  useEffect(() => {
    const getData = async () => {
      const response = await getCashDrawerReport(id);

      setCashDrawerReport(response.data?.getPOSRegisterReport);
    };

    getData();
  }, [getCashDrawerReport, id]);

  const transactionColumns = [
    {
      label: 'Cash',
      key: 'cash',
    },
    {
      label: 'Card',
      key: 'card',
    },
    {
      label: 'No of Transactions',
      key: 'num_transactions',
    },
  ];

  const columns = [
    {
      label: 'Ticket Name',
      key: 'name',
    },
    {
      label: 'Quantity',
      key: 'qty',
    },
    {
      label: 'Price',
      key: 'price',
    },
  ];

  function renderRows(tick) {
    return tick;
  }

  return !cashDrawerReport ? (
    <div />
  ) : (
    <>
      <div
        style={{
          justifyContent: 'space-between',
          display: 'flex',
          paddingTop: 20,
          paddingRight: 40,
        }}
      >
        {eventData && (
          <EventHeader event={eventData} margin={'0px 40px 0px 40px'} />
        )}
        <Column noBorder>
          <CashDrawerReportPrint
            eventId={id}
            date={event?.start_date}
            disable={!cashDrawerReport?.results?.length}
            transactionData={cashDrawerReport}
          />

          <HelpModals />
        </Column>
      </div>
      <Container>
        <ContainerHeader
          borderWidth={'1px'}
          style={{ position: 'relative', width: '97%' }}
        >
          <TitleContainer
            style={{
              flexDirection: 'row',
              width: '95%',
              justifyContent: 'space-between',
            }}
          >
            <FilterContainer>
              <Text
                type="heading"
                color="#3C4144"
                inlineStyle={{ marginRight: 25, whiteSpace: 'nowrap' }}
              >
                My Box Office Report
              </Text>
            </FilterContainer>
            <FilterContainer>
              {cashDrawerReport && (
                <>
                  <Icon
                    icon="Dashboard-User-Profile"
                    size={24}
                    color="#3C4144"
                  />
                  <Text
                    type="heading"
                    color="#3C4144"
                    inlineStyle={{
                      marginRight: 25,
                      whiteSpace: 'nowrap',
                      fontWeight: 600,
                    }}
                  >
                    {cashDrawerReport?.user?.formatted_name}
                  </Text>
                </>
              )}
            </FilterContainer>
          </TitleContainer>
        </ContainerHeader>
        <div style={{ padding: 20 }}>
          <Table
            items={[
              {
                cash: cashDrawerReport?.cash,
                card: cashDrawerReport?.card,
                num_transactions: cashDrawerReport?.num_transactions,
              },
            ]}
            columns={transactionColumns}
            renderRows={renderRows}
          />

          <Spacer size={20} />

          <Table
            items={cashDrawerReport.ticket_breakdown_data}
            columns={columns}
            renderRows={renderRows}
          />
        </div>
      </Container>
    </>
  );
};
